<template>
    <ProgressSpinner 
        :style="{'width': '50px','height': '50px'}"
        strokeWidth="8" 
        fill="transparent" 
        animationDuration=".9s"
        aria-label="Custom ProgressSpinner"
        :class="props.class"
    />
</template>
<script setup>
    import ProgressSpinner from 'primevue/progressspinner';
    import { defineProps } from 'vue';

    const props = defineProps({
        class: {
            type: String,
            required: false,
            default: ''
        }
    });
</script>